import React from "react";
import PropTypes from "prop-types";
import { Grid, Button } from "semantic-ui-react";
import Link from "next/link";
import { Title, Segmant, ImageItem, CityCustomFeed } from "../../components";

const CityActivities = ({
  activityData,
  onClick,
  usertype,
  display,
  ...props
}) => {
  return (
    <Grid stackable>
      {activityData.map((activity, index) => (
        <Grid.Row key={index}>
          <Grid.Column width={5}>
            {/* <Link {...props}>
              <a style={{ cursor: 'pointer' }} target="_blank">
                <ImageItem src={activity.image} />
              </a>
            </Link> */}
            <>
              {activity.cityimages.length > 0 ? (
                <>
                  <Link
                    {...props}
                    style={{ cursor: "pointer" }}
                    target="_blank"
                    href={"/City/" + activity.cityname}
                    title={activity.cityname}
                  >
                    {/* <a
                      style={{ cursor: "pointer" }}
                      target="_blank"
                      href={"/City/" + activity.cityname}
                      title={activity.cityname}
                    > */}
                    <div className="realtor_nh_images">
                      <ImageItem
                        src={activity.cityimages[0].imageurl}
                        alt="City Image"
                        title="City Image"
                      />
                    </div>
                    {/* </a> */}
                  </Link>
                </>
              ) : (
                <Link {...props} style={{ cursor: "pointer" }} target="_blank">
                  {/* <a style={{ cursor: "pointer" }} target="_blank"> */}
                  <div className="realtor_nh_images">
                    <ImageItem
                      src={`${process.env.NEXT_PUBLIC_CDN_ID}static/images/defaultadd.jpg`}
                      alt="City Image"
                      title="City Image"
                    />
                  </div>
                  {/* </a> */}
                </Link>
              )}
            </>
          </Grid.Column>
          <Grid.Column width={11}>
            <Link
              {...props}
              style={{ cursor: "pointer" }}
              target="_blank"
              href={"/City/" + activity.cityname}
              title={activity.cityname}
            >
              {/* <a
                style={{ cursor: "pointer" }}
                target="_blank"
                href={"/City/" + activity.cityname}
                title={activity.cityname}
              > */}
              <Title
                color="blue"
                name={activity.heading.replace("Review on", "")}
              />
              {/* </a> */}
            </Link>

            <Segmant>
              <CityCustomFeed
                className="realtor-summary-wrapper"
                data={activity.heading}
                head={<div>Reviews:</div>}
                date={activity.createDate}
                cityname={activity.cityname}
              />
            </Segmant>
          </Grid.Column>
        </Grid.Row>
      ))}
    </Grid>
  );
};

CityActivities.propTypes = {
  activityData: PropTypes.array.isRequired,
};

export default CityActivities;
